import React from "react";

export default function FiberImagesSummary({ fiberImages = [] }) {
    if (!fiberImages || !fiberImages.length) {
        return <span className="text-muted small italic p-2">No images uploaded</span>;
    }

    const counts = fiberImages.reduce((acc, img) => {
        const type = img.imageType || "Other";
        acc[type] = (acc[type] || 0) + 1;
        return acc;
    }, {});

    return (
        <div className="image-summary-container p-1" style={{ minWidth: '180px' }}>
            <div className="fw-bold text-primary border-bottom mb-2 pb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                Uploaded Images ({fiberImages.length})
            </div>
            <div className="d-flex flex-column gap-2 mt-2">
                {Object.entries(counts).map(([type, count]) => (
                    <div key={type} className="d-flex justify-content-between align-items-center gap-4" style={{ fontSize: '0.85rem' }}>
                        <div className="d-flex align-items-center gap-2">
                            <i className="bi bi-image text-muted"></i>
                            <span className="text-secondary">{type}:</span>
                        </div>
                        <span className="fw-bold text-dark">{count}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
